<template>
  <div class="main-price">
    <!-- <vheader></vheader> -->
    <div class="content">
      <div class="container">
        <div class="title">产品价格详情</div>
        <p class="desc">更低定价，更高享受，每一笔花费都物超所值</p>
        <!-- <div class="btn" @click="dialogVisible = true">立即购买</div> -->
        <!-- <div class="banner">
          <div class="box_1">
            <div class="box_2">
              <span class="text_4">特惠体验价</span>
              <span class="text_5">¥</span>
              <span class="text_6">9.9</span>
              <span class="text_7">/15天</span>
            </div>
            <div class="text_8">10个模板，20个看板套餐</div>
          </div>
        </div> -->
        <div class="price-group">
          <div class="single-price" v-for="(item, index) of priceList" :key="item.index">
            <div class="top" :class="{
              grjc: item.bb == '个人基础版',
              tybg: item.bb == '基础版',
              ptbg: item.bb == '普及版',
              jcbg: item.bb == '高级版',
              jjbg: item.bb == '旗舰版',
              zybg: item.bb == '专属版',
            }">
              <div class="price-content">
                <!-- <div class="limit">
                  <img src="../../assets/images/limit.png" width="80%" alt="" />
                </div> -->
                <div class="banben" :style="{ color: item.textColor }">
                  {{ item.bb }}
                </div>
                <!-- <div class="number">
                  {{ item.sl }}
                </div> -->
                <div class="date-price">
                  <p :style="{ color: item.textColor }">
                    <span style="font-size: 32px">￥</span><span style="font-size: 50px">{{ item.price }}</span><span
                      style="font-size: 20px">/{{ item.time ? item.time : '年' }}</span>
                  </p>

                  <!-- 立即购买按钮 -->
                  <div class="buy_btn" :style="{ color: item.color, background: item.bg }"
                    :class="{ trailClass: item.bb == '体验版' }" @click="onClickBuy(item, index)">{{ '立即购买' }}</div>
                  <!-- {{ item.bb == "体验版" ? "元/30天免费" : "元/年" }} -->
                </div>
              </div>
              <!-- <div
                class="start"
                :class="{ startbg: item.bb !== '体验版' }"
                @click="join"
              >
                <span>立即开通</span>
              </div> -->
              <!-- <Modal
                v-model="modal1"
                title="登录提示"
                class-name="case-group"
                @on-ok="ok"
              >
                <p>您还未登录账号</p>
                <div class="dl">
                  <a href="javascript:" @click="toLink('/login')">用户登录</a>
                </div>
              </Modal> -->
            </div>
            <div class="main">
              <div class="min-title">详情</div>
              <ul>
                <!-- <li>
                  <p>软件安装包</p>
                  <span
                    ><img
                      :src="
                        item.rj == true
                          ? require('@/assets/images/true.png')
                          : require('@/assets/images/false.png')
                      "
                      alt=""
                  /></span>
                </li> -->
                <li>
                  <p>可解锁模板</p>
                  <span>{{ item.yjs }}</span>
                </li>
                <!-- <li v-if="item.gj">
                  <p>解锁高级模版权限</p>
                  <span><img :src="
                    item.gj == true
                      ? require('@/assets/images/true.png')
                      : require('@/assets/images/false.png')
                  " alt="" /></span>
                </li> -->
                <li>
                  <p>可创建看板</p>
                  <span>{{ item.kb }}</span>
                </li>
                <li>
                  <p>看板密码访问</p>
                  <span><img :src="
                    item.kbpassword == true
                      ? require('@/assets/images/true.png')
                      : require('@/assets/images/false.png')
                  " alt="" /></span>
                </li>
                <li v-if="item.kblj != ''">
                  <p>看板互联</p>
                  <span v-if="item.kblj == ''"><img :src="require('@/assets/images/false.png')" alt="" /></span>
                  <span v-else-if="item.kblj === true"><img :src="require('@/assets/images/true.png')" alt="" /></span>
                  <span v-else>{{ item.kblj }}</span>
                </li>
                <li v-if="item.create != ''">
                  <p>看板PPT</p>
                  <span v-if="item.create == ''">
                    <img :src="require('@/assets/images/false.png')" alt="">
                  </span>
                  <span v-else>{{ item.create }}</span>
                </li>
                <li>
                  <p>文件存储空间</p>
                  <span><img v-if="item.file == true" src="../../assets/images/true.png" alt="" />
                    <span v-else>{{ item.file }}</span>
                  </span>
                </li>
                <li v-if="item.windowName">
                  <p>自定义系统名称</p>
                  <span><img :src="
                    item.windowName == true
                      ? require('@/assets/images/true.png')
                      : require('@/assets/images/false.png')
                  " alt="" /></span>
                </li>
                <li v-if="item.windowLogo">
                  <p>自定义系统LOGO</p>
                  <span><img :src="
                    item.windowLogo == true
                      ? require('@/assets/images/true.png')
                      : require('@/assets/images/false.png')
                  " alt="" /></span>
                </li>
                <li v-if="item.windowbgi">
                  <p>自定义看板背景</p>
                  <span><img :src="
                    item.windowbgi == true
                      ? require('@/assets/images/true.png')
                      : require('@/assets/images/false.png')
                  " alt="" /></span>
                </li>
                <li v-if="item.data">
                  <p>数据支持</p>
                  <span>{{ item.data }}</span>
                </li>
                <li v-if="item.null1 !== ''">
                  <p></p>
                  <span>{{ item.null1 }}</span>
                </li>
                <li v-if="item.null2 !== ''" id="line">
                  <p></p>
                  <span id="line">{{ item.null2 }}</span>
                </li>
                <li v-if="item.null3 !== ''">
                  <p></p>
                  <span>{{ item.null3 }}</span>
                </li>
                <li>
                  <p>多终端随时使用和访问</p>
                  <span><img :src="
                    item.dzd == true
                      ? require('@/assets/images/true.png')
                      : require('@/assets/images/false.png')
                  " alt="" /></span>
                </li>
                <li>
                  <p>模板，软件升级</p>
                  <span><img :src="
                    item.sj == true
                      ? require('@/assets/images/true.png')
                      : require('@/assets/images/false.png')
                  " alt="" /></span>
                </li>
              </ul>
            </div>
            <!-- <div
              class="bottom"
              :class="{
                tyb: item.bb == '体验版',

                jcb: item.bb == '基础版',
                jjb: item.bb == '旗舰版',
                zyb: item.bb == '专属版',
              }"
            >
              <div class="product">
                <div class="min-title">详情</div>
                <ul>
                  <li>
                    <p>单价</p>
                    <span>{{ item.dj }} 元/每张</span>
                  </li>
                  <li>
                    <p>模板种类</p>
                    <span>{{ item.zszl }}</span>
                  </li>
                  <li>
                    <p>域名</p>
                    <span>{{ item.ym }}</span>
                  </li>
                  <li>
                    <p>技术支持</p>
                    <span>{{ item.jszc }}</span>
                  </li>
                  <li>
                    <p>ssl加密证书</p>
                    <span>{{ item.ssl }}</span>
                  </li>
                  <li>
                    <p>查询</p>
                    <span>{{ item.cx }}</span>
                  </li>
                </ul>
              </div>
            </div> -->
          </div>
        </div>
      </div>
      <!-- <div class="benefit">
            <div class="container">
                <div class="title">
                    企业版四大权益
                </div>
                <div class="benefit-group">
                    <div class="single-benefit">
                        <div class="icon">
                            <img src="../assets/images/icon-kefu.png" alt="">
                        </div>
                        <div class="min-title">
                            唯一认证可查
                        </div>
                        <p>每张证书存在专属二维码 <br> 唯一标识</p>
                    </div>
                    <div class="single-benefit">
                        <div class="icon">
                            <img src="../assets/images/icon-kefu.png" alt="">
                        </div>
                        <div class="min-title">
                            海量素材随心用
                        </div>
                        <p>多种精美模板可选创作<br> 更省心</p>
                    </div>
                    <div class="single-benefit">
                        <div class="icon">
                            <img src="../assets/images/icon-kefu.png" alt="">
                        </div>
                        <div class="min-title">
                            项目版本记录管理
                        </div>
                        <p>支持项目记录 <br>回溯、追回更方便</p>
                    </div>
                    <div class="single-benefit">
                        <div class="icon">
                            <img src="../assets/images/icon-kefu.png" alt="">
                        </div>
                        <div class="min-title">
                            海量素材随心用
                        </div>
                        <p>专属客服 响应迅速 <br>一对一解决问题</p>
                    </div>
                </div>
            </div>
        </div> -->
    </div>
    <!-- <div class="education">
      <div class="container">
        <div class="title">教育公益版</div>
        <p>助力公益机构数字化，用数字化定义颁发标准，让颁奖活动更有趣</p>
        <div class="btn-group">
          <div class="btn">
            <a href="http://app.yiyunbanfa.com" target="_blank">立即申请</a>
          </div>

        
        </div>
      </div>
    </div> -->
    <el-dialog :visible.sync="dialogVisible" width="30%">
      <template #title>
      </template>
      <div class="success_dialog" style="text-align: center">
        <div class="dialog_first">
          <i class="el-icon-circle-check" style="color: #29B000; font-size: 30px; font-weight: 700;"></i>
          <span style="color: #29B000; font-size: 20px; margin-left: 10px; font-weight: 700;">购买成功</span>
        </div>
        <div style="color: #999; font-size: 16px; margin-top: 30px;">
          扫一扫下方的二维码，领取你的返现红包
        </div>
        <div>
          <img style="width: 226px; height: 226px" src="../../assets/images/qr-code.png" alt="" />
        </div>
        <el-button type="primary" style="margin-top: 15px; margin-bottom: 20px;" @click="onClickGo">立即体验</el-button>
      </div>
    </el-dialog>

    <el-dialog :visible.sync="dialogHelpVisible" width="25%">
      <template #title>
        <div style="font-size: 18px; color: #000;">详情咨询微信</div>

      </template>
      <div class="success_dialog" style="text-align: center">
        <!-- <div class="dialog_first">
          <i class="el-icon-circle-check" style="color: #29B000; font-size: 30px; font-weight: 700;"></i>
          <span style="color: #29B000; font-size: 20px; margin-left: 10px; font-weight: 700;">购买成功</span>
        </div> -->
        <div style="color: #999; font-size: 16px; margin-top: 30px;">
          扫描下方二维码，联系您的专属客服
        </div>
        <div>
          <img style="width: 226px; height: 226px" src="../../assets/images/qr-code.png" alt="" />
        </div>
        <!-- <el-button type="primary" style="margin-top: 15px; margin-bottom: 20px;" @click="onClickGo">立即体验</el-button> -->
      </div>
    </el-dialog>


    <!-- 含有手机号，验证码的登录el-dialog -->
    <el-dialog title="账号登录" :visible.sync="loginDialogVisible" width="30%" z-index="1000">
      <template #title>
        <div style="font-size: 18px; color: #000;">账号登录</div>
      </template>
      <Login @login="handleLogin" />
    </el-dialog>

    <div class="buy_dialog">
      <el-dialog title="套餐选择" :visible.sync="buyDialogVisible" width="1050px" :before-close="handleBuyClose">
        <template #title>
          <div class="main_title">
            <div style="font-size: 18px; color: #000;">套餐选择</div>
            <div style="font-size: 14px; color: #1989FF; cursor: pointer;" @click="dialogHelpVisible = true">如遇问题，请联系客服
            </div>
          </div>
        </template>
        <!-- 使用flex生成左右两个div，比例为3:1 -->
        <div class="grid">
          <div class="grid_cell u-1of3">
            <div class="of3_first">
              <div class="title">
                <!-- <div class="item"></div> -->
                <!-- <div class="title_name">选择套餐</div> -->
              </div>
              <div class="package">
                当前套餐：{{ currentPackageName }}
              </div>
            </div>

            <!-- <div class="of3_second">
              <div v-for="(item, index) of computedPriceList" class="package_item"
                :class="{ 'select_item': currentPackageIndex == index }" @click="onSelectPackage(item, index)"
                :key="index">
                <div class="name">
                  {{ item.bb }}
                </div>
                <div class="price">
                  <span>￥</span>
                  <span style="font-size: 18px;">{{ item.price }}</span>
                  <span>/{{ item.time ? item.time : '年' }}</span>
                </div>

                <div class="select" v-if="currentPackageIndex == index">
                  <img class="image" src="../../assets/images/package_check.png" alt="" />
                </div>
              </div>
            </div> -->

            <el-tabs v-model="tabName" @tab-click="onTabClick">
              <el-tab-pane label="选择套餐" name="package">
                <div class="of3_second">

                  <div v-for="(item, index) of computedPriceList" class="package_item"
                    :class="{ 'select_item': currentPackageIndex == index }" @click="onSelectPackage(item, index)"
                    :key="index">
                    <div class="name">
                      {{ item.bb }}
                    </div>
                    <div class="price">
                      <span>￥</span>
                      <span style="font-size: 18px;">{{ item.price }}</span>
                      <span>/{{ item.time ? item.time : '年' }}</span>
                    </div>

                    <!-- 选中右下角 -->
                    <div class="select" v-if="currentPackageIndex == index">
                      <img class="image" src="../../assets/images/package_check.png" alt="" />
                    </div>
                  </div>
                </div>

              </el-tab-pane>
              <el-tab-pane label="选择模版" name="template">
                <div class="of3_second">

                  <div v-for="(item, index) of templateList" class="package_item_template"
                    :class="{ 'select_item_template': currentPackageIndex == index }"
                    @click="onSelectPackage(item, index)" :key="item.bb">
                    <div class="name">
                      {{ item.bb }}
                    </div>
                    <div class="patch">
                      {{ index == 1 ? '' : '赠送两个看板' }}
                    </div>
                    <div class="price">
                      <span>￥</span>
                      <span style="font-size: 18px;">{{ item.price }}</span>
                    </div>

                    <!-- 选中右下角 -->
                    <div class="select" v-if="currentPackageIndex == index">
                      <img class="image" src="../../assets/images/template_check.png" alt="" />
                    </div>
                  </div>
                </div>
              </el-tab-pane>
            </el-tabs>

            <div class="of3_third">
              <div class="title">
                <div class="item"></div>
                <div class="title_name">支付方式</div>
              </div>

              <div class="payway">
                <div class="payway_item" :class="{ 'select_payway': index === currentPaywayIndex }"
                  v-for="(item, index) of paywayItem" @click="onSelectPayway(item, index)" :key="index">
                  <img :src='require(`@/assets/images/${item}.png`)' width="20px" />
                  <div>{{ item }}</div>
                </div>
              </div>
            </div>

          </div>
          <div class="grid_cell u-1of1">
            <div class="of1_first" v-if="!qrCodeShow">
              <div class="of1_first_left">域</div>
              <div class="of1_first_right">
                <div class="name">域贝数据可视化应用平台</div>
                <div class="time" style="font-size: 12px;">订购日期{{ getTime() }}</div>
              </div>
            </div>
            <div class="of1_second">
              <!-- 分行方案名称，购买时长 -->
              <div class="of1_second_item">

                <div>方案名称</div>
                <div>{{ currentPackage.bb }}</div>
              </div>
              <div class="of1_second_item" v-if="activeIndex == 0">

                <div>购买时长</div>
                <div>{{ currentPackage.bb == '体验版' ? '7天' : '1年' }}</div>
              </div>
              <div class="of1_second_item" v-if="activeIndex == 0">

                <div>套餐到期时间</div>
                <div>{{ getYearAfterTime(currentPackage) }}</div>
              </div>
              <div class="of1_second_item" v-if="activeIndex == 1">
                <div>购买数量</div>
                <div> <el-input-number v-model="num" @change="handleChange" :disabled="qrCodeShow" :min="minValue" :max="100" size="mini"
                    label="描述文字"></el-input-number>
                </div>
              </div>
              <div class="of1_second_item">

                <div>订单总额</div>
                <div>¥ {{ currentPackage.price * num }}</div>
              </div>
            </div>
            <div class="of1_third">
            </div>

            <div class="of1_four" v-if="!qrCodeShow">
              <div>应付金额</div>
              <div>¥ {{ currentPackage.price * num }}</div>
            </div>

            <div class="of1_five" v-if="!qrCodeShow">
              <!-- 提交订单按钮 -->
              <el-button type="primary" :disabled="!checked" @click="onSubmitOrder(currentPaywayIndex)">提交订单</el-button>
            </div>

            <div class="of1_six" v-if="!qrCodeShow">
              <!-- 我已阅读并同意协议 -->
              <el-checkbox v-model="checked">我已阅读并同意</el-checkbox><a>《服务协议》</a>
            </div>
            <div v-if="qrCodeShow">
              <div class="qrcode1" id="qrcode1" ref="qrcode1"></div>
            </div>
          </div>



        </div>

      </el-dialog>
    </div>

  </div>
</template>

<script>
// import vheader from "../components/header.vue";
// import vfooter from "../components/footer.vue";
import { sendCode, createWxPay, queryPayStatus, getAliPayHtml, getUserPackage, tryPackage } from '@/api/price'
import Login from '../Login/Login.vue'
import moment from 'moment'
import QRCode from "qrcodejs2";
import { Loading, Message } from 'element-ui';

export default {
  components: {
    // vheader,
    // vfooter,
    Login
  },
  computed: {
    computedPriceList() {
      if (this.activeIndex == 0) {
        return this.news == false ? this.priceList.filter(item => item.bb !== '体验版') : this.priceList
      } else {
        return this.templateList
      }
    },

    computedPriceEnum() {
      if (this.activeIndex == 0) {
        return this.news == false ? this.priceEnum.filter(item => item != 'PERSONAL') : this.priceEnum
      } else {
        return this.templateEnum
      }
    }
  },
  data() {
    return {
      modal1: false,
      text: "免费7天，加福利官进群可定期领取免费使用券",
      dialogVisible: false,
      priceList: [
        {
          id: "000",
          bb: "体验版",
          color: '#3A95FE',
          time: "7天",
          bg: '#fff',
          textColor: '#000',
          // price: 9.9,
          price: 0.1,
          rj: true,
          yjs: "1个示例模板",
          gj: false,
          kb: "1个",
          kbpassword: true,
          kblj: false,
          create: "",
          file: true,
          windowName: false,
          windowLogo: false,
          windowbgi: true,
          data: null,
          null1: "",
          null2: "",
          null3: "",
          dzd: true,
          sj: true,
        },
        {
          id: "001",
          bb: "基础版",
          color: '#61C768',
          textColor: '#fff',
          bg: '#fff',
          // price: 980,
          price: 98,
          rj: true,
          yjs: "1个",
          gj: false,
          kb: "2个",
          kbpassword: true,
          kblj: '3个',
          create: "3个",
          file: true,
          windowName: true,
          windowLogo: true,
          windowbgi: true,
          data: "自变化300组",
          null1: "",
          null2: "",
          null3: "",
          dzd: true,
          sj: true,
        },
        {
          id: "003",
          bb: "高级版",
          color: '#3C6998',
          textColor: '#fff',
          bg: '#fff',
          // price: 2980,
          price: 358,
          rj: true,
          yjs: "5个",
          gj: true,
          kb: "10个",
          kbpassword: true,
          kblj: true,
          create: "6个",
          file: "双倍空间",
          windowName: true,
          windowLogo: true,
          windowbgi: true,
          data: "自变化300组",
          null1: "",
          null2: "",
          null3: "",
          // data: "数据库实时对接",
          // null1: "主流数据库配置接入",
          // null2: "支持http接口(get/post请求)\n 调用动态接入",
          // null3: "实时数据自动更新",
          dzd: true,
          sj: true,
        },
        {
          id: "004",
          bb: "旗舰版",
          // price: 9980,
          price: 1998,
          color: '#FFFFFF',
          textColor: '#fff',
          bg: 'linear-gradient(110deg, #0091F1 0%, #005EDC 100%)',
          rj: true,
          yjs: "不限",
          gj: true,
          kb: "不限",
          kbpassword: true,
          kblj: true,
          create: "不限",
          file: "四倍独享空间",
          windowName: true,
          windowLogo: true,
          windowbgi: true,
          data: "数据库实时对接",
          null1: "主流数据库配置接入",
          null2: "支持http接口(get/post请求)\n 调用动态接入",
          null3: "实时数据自动更新",
          dzd: true,
          sj: true,
        },
        // {
        //   id: "004",
        //   bb: "旗舰版",
        //   // price: 9980,
        //   price: 998,
        //   color: '#0075E6',
        //   textColor: '#fff',
        //   bg: '#fff',
        //   rj: true,
        //   yjs: "20个",
        //   gj: true,
        //   kb: "40个",
        //   kbpassword: true,
        //   kblj: true,
        //   create: "10个",
        //   file: "三倍空间",
        //   windowName: true,
        //   windowLogo: true,
        //   windowbgi: true,
        //   data: "数据库实时对接",
        //   null1: "主流数据库配置接入",
        //   null2: "支持http接口(get/post请求)\n 调用动态接入",
        //   null3: "实时数据自动更新",
        //   dzd: true,
        //   sj: true,
        // },
        // {
        //   id: "005",
        //   bb: "专属版",
        //   // price: 19980,
        //   price: 1998,
        //   color: '#FFFFFF',
        //   textColor: '#fff',
        //   bg: 'linear-gradient(110deg, #0091F1 0%, #005EDC 100%)',
        //   rj: true,
        //   yjs: "不限",
        //   gj: true,
        //   kb: "不限",
        //   kbpassword: true,
        //   kblj: true,
        //   create: "不限",
        //   file: "四倍独享空间",
        //   windowName: true,
        //   windowLogo: true,
        //   windowbgi: true,
        //   data: "数据库实时对接",
        //   null1: "主流数据库配置接入",
        //   null2: "支持http接口(get/post请求)\n 调用动态接入",
        //   null3: "实时数据自动更新",
        //   dzd: true,
        //   sj: true,
        // },
      ],
      priceEnum: ['PERSONAL', 'ENTERPRISE_BASIC', 'ENTERPRISE_DELUXE', 'ENTERPRISE_FLAGSHIP', 'ENTERPRISE_EXCLUSIVE'],
      templateList: [
        {
          bb: "基础模版",
          // price: 298,
          price: 50,
        },
        {
          bb: "定制模版(800元起步)",
          price: 100,
        }
      ],
      templateEnum: [
        'TEMPLATE_BASIC', 'TEMPLATE_CUSTOM'
      ],
      tabName: 'package',
      active: "1年",
      dl: false,
      loginDialogVisible: false,
      buyDialogVisible: false,
      form: {
        phone: "",
        code: "",
      },
      showcode: true,
      username: "",
      password: "",
      code: "",
      currentPackageIndex: -1,
      currentPackage: {},
      paywayItem: ['微信'],
      currentPaywayIndex: 0,
      currentPayway: '微信',
      checked: true,// 默认勾选 checked: false,
      // 二维码展示
      qrCodeShow: false,
      userOrdersId: null,
      timer: null,
      currentPackageName: null,
      state: null,
      qr: null,
      news: true,
      dialogHelpVisible: false,
      activeIndex: 0,
      num: 1,
      minValue: 1,
    };
  },

  created() {
    this.currentPackageIndex = 0
    this.currentPackage = this.priceList[0]
  },

  watch: {
    // 监听router变化
    $route(to, from) {
      if (to.query.login != from.query.login) {
        const login = this.$route.query.login == 'true' ? true : false

        localStorage.removeItem('token')

        if (this.$route.query.login && !login) {
          this.loginDialogVisible = true
        }
      }
    },
    currentPackageIndex: function (val) {
      if (this.activeIndex == 1 && this.currentPackageIndex == 1) {
        this.num = 8
        this.minValue = 8
      } else {
        this.num = 1
        this.minValue = 1
      }
    },
  },

  methods: {
    toLink(add) {
      this.$router.push(add);
    },
    join() {
      if (this.dl == "false") {
        this.modal1 = true;
      }
    },

    onTabClick(tab) {
      this.activeIndex = tab.index
      this.currentPackageIndex = 0
      clearInterval(this.timer)
      this.qrCodeShow = false
      this.currentPackage = this.computedPriceList[this.currentPackageIndex]
    },

    handleChange(value) {
      // 判断value是否为数字
      if (isNaN(value)) {
        this.num = 1
        return
      }
    },

    handleBuyClose() {
      this.qrCodeShow = false
      this.buyDialogVisible = false
      clearInterval(this.timer)
    },

    getTime() {
      // 以年月日时分秒格式生成时间
      return moment().format("YYYY年MM月DD日 HH:mm:ss");
    },

    getYearAfterTime() {
      if (this.currentPackage.bb == '体验版') {
        // 加7天
        return moment().add(7, "days").format("YYYY年MM月DD日");
      }
      // 以年月日时分秒格式生成一年后的时间
      return moment().add(1, "year").format("YYYY年MM月DD日");
    },

    async onClickBuy(item, index) {
      // 获取token
      let token = localStorage.getItem("token");
      if (token) {
        // if (item.bb == '体验版') {
        //   // if (this.currentPackageName == '体验版') {
        //     const res = await tryPackage()
        //     console.log(res)
        //     if (res.code == 0) {
        //       Message({
        //         message: res.msg,
        //         type: 'error',
        //         customClass: "global-messageZindex",
        //         duration: 3 * 1000
        //       })
        //       return
        //     } else if (res.code == 1) {
        //       window.location.href = 'http://yb.yuzanyun.com/#/?state' + res.payload.state
        //       return
        //     }
        //   // }
        //   // window.location.href = 'http://122.228.252.39:18000/#/'
        //   return
        // }

        const res = await getUserPackage()
        if (res.code == 1) {
          this.currentPackageName = res.payload.name
          this.news = res.payload.news
        }

        if (!this.news) {
          index = index - 1;
        }

        if (index < 0) {
          index = 0
        }

        this.currentPackageIndex = index
        this.currentPackage = this.computedPriceList[index]
        this.buyDialogVisible = true;
      } else {
        this.loginDialogVisible = true;
      }
    },

    async handleLogin() {
      this.loginDialogVisible = false

      const token = localStorage.getItem("token");

      if (token) {
        const res = await getUserPackage()
        if (res.code == 1) {
          this.currentPackageName = res.payload.name
        }
      }

      this.currentPackageIndex = 0
      this.currentPackage = this.computedPriceList[0]

      this.$nextTick(() => {
        this.buyDialogVisible = true;
      })
    },

    async onSendCode() {
      if (this.username) {
        this.sendTime = true;
        let res = await sendCode({ number: this.username })
      } else {
        Message.error("请输入手机号");
      }
    },

    onSelectPackage(item, index) {
      clearInterval(this.timer)
      this.currentPackageIndex = index
      this.currentPackage = item
      this.qrCodeShow = false
    },

    onSelectPayway(item, index) {
      this.qrCodeShow = false
      this.currentPaywayIndex = index
      this.currentPayway = item
    },

    async onSubmitOrder(currentPaywayIndex) {
      // 先清除上一次的二维码
      console.log(this.currentPackageIndex, this.news)
      if (this.currentPackageName == '个人体验版' && this.news == false) {
        Message({
          message: '您已经体验过了',
          type: 'error',
          customClass: "global-messageZindex",
          duration: 3 * 1000
        })
        return
      }

      if (currentPaywayIndex == 0) {
        this.wxPay()
      } else {
        this.aliPay()
      }

    },

    async aliPay() {
      const res = await getAliPayHtml({ packType: this.computedPriceEnum[this.currentPackageIndex] })

      if (res.code == 0) {
        Message({
          message: res.msg,
          type: 'error',
          customClass: "global-messageZindex",
          duration: 3 * 1000
        })
      }

      // 页面跳转到res
      const div = document.createElement('div');
      div.innerHTML = res; // html code
      document.body.appendChild(div);
      document.forms[0].submit();
    },

    async wxPay() {

      // loading
      let loadingInstance = Loading.service({
        text: "正在生成二维码...",
      });

      let res = null

      if (this.activeIndex == 1) {
        res = await createWxPay({ packType: this.computedPriceEnum[this.currentPackageIndex], templateId: this.template?.id, amount: this.num })

      } else {
        res = await createWxPay({ packType: this.computedPriceEnum[this.currentPackageIndex] })
      }


      if (res.code == 0) {
        Message({
          message: res.msg,
          type: 'error',
          customClass: "global-messageZindex",
          duration: 3 * 1000
        })
        loadingInstance.close();
        return
      }

      this.userOrdersId = res.payload.userOrdersId
      this.qrCodeShow = true

      this.state = res.payload.state

      this.$nextTick(() => {

        this.qr = new QRCode("qrcode1", {
          width: 210,
          height: 210, // 高度
          text: res.payload.qrcode, // 二维码内容
          // render: 'table', // 设置渲染方式（有两种方式 table和canvas，默认是canvas）
          colorDark: "#000000",
          colorLight: "#ffffff",
          correctLevel: QRCode.CorrectLevel.H
        });

        loadingInstance.close();
        this.timer = setInterval(() => {
          this.checkOrderStatus()
        }, 3000)


      })
    },

    async checkOrderStatus() {
      const res = await queryPayStatus(this.userOrdersId)
      if (res.payload.state == 'PAID') {
        clearInterval(this.timer)
        this.qrCodeShow = false
        this.buyDialogVisible = false

        // 提示支付成功
        // this.$message({
        //   message: "支付成功",
        //   type: "success",
        //   duration: 5000,
        //   customClass: "global-messageZindex"
        // });

        this.dialogVisible = true;

        // window.location.href = 'http://yb.yuzanyun.com/#/login?state=' + this.state
      }
    },

    onClickGo() {
      window.location.href = 'http://yb.yuzanyun.com/#/login?state=' + this.state
    },
  },



  async mounted() {
    this.dl = localStorage.getItem("dl");

    const alipaySuccess = this.$route.query.alipaySuccess
    if (alipaySuccess == 'true') {
      this.$message({
        type: 'success',
        message: '支付成功',
        duration: 5000,
        customClass: "global-messageZindex"
      })
    }

    const token = localStorage.getItem("token");


    // if (token) {
    //   const res = await getUserPackage()
    //   if (res.code == 1) {
    //     this.currentPackageName = res.payload.name
    //   }
    // }
  },


};
</script>

<style scoped lang="less">
@charset "UTF-8";

.select_item_template {
  background: linear-gradient(315deg, #FDFEFF 0%, #EFF7FF 100%);
  border: 1px solid #1989FF !important;
  border-radius: 6px;
}

.package_item_template {
  margin-top: 10px;
  border-radius: 6px;
  border: 1px solid #cdcdcd;
  // width: 226px;
  width: 300px;
  height: 110px;
  color: #000;
  position: relative;

  .name {
    width: 100%;
    text-align: center;
    margin-top: 19px;
  }

  .patch {
    width: 100%;
    height: 10px;
    text-align: center;
    margin-top: 5px;
    font-size: 12px;
    color: #999;
  }

  .price {
    margin-top: 8px;
    width: 100%;
    text-align: center;
    font-size: 14px;
    color: #000;
  }

  .select {
    background: url("../../assets/images/template_select.png");
    background-size: 100% 100%;
    width: 30px;
    height: 30px;
    position: absolute;
    right: 0;
    bottom: 0;

    .image {
      position: absolute;
      right: 0px;
      bottom: 0px;
      width: 60%;
      height: 60%;
    }
  }
}

.global-messageZindex {
  z-index: 10000 !important;
}

/deep/ .el-input-number__decrease {
  height: 26px !important;
  line-height: 26px !important;
}

/deep/ .el-input-number__increase {
  height: 26px !important;
  line-height: 26px !important;
}

.success_dialog {
  width: 100%;
  height: 100%;


}

.dialog_first {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
}

.main-price ::v-deep .el-dialog {
  border-radius: 12px !important;
}

.main-price ::v-deep .el-dialog__body {
  padding: 0px;
}



.main_title {
  display: flex;
  width: 95%;
  justify-content: space-between;
  align-items: center;
  font-size: 20px;
  color: #191919;
}

.main-price .buy_dialog .grid {
  display: flex;
}

.main-price .buy_dialog .grid .grid_cell {
  flex: 1;
}

.main-price .buy_dialog .grid .grid_cell.u-1of3 {
  flex: 0 0 700px;
  margin-left: 10px;
  margin-top: 10px;
  padding-left: 10px;
}

.main-price .buy_dialog .grid .grid_cell.u-1of3 .of3_first {
  display: flex;
  justify-content: space-between;
}

.main-price .buy_dialog .grid .grid_cell.u-1of3 .of3_first .title {
  display: flex;
  justify-content: flex-start;
  height: 16px;
  line-height: 16px;
}

.main-price .buy_dialog .grid .grid_cell.u-1of3 .of3_first .title .item {
  width: 2px;
  height: 16px;
  background-color: #1989FF;
}

.main-price .buy_dialog .grid .grid_cell.u-1of3 .of3_first .title .title_name {
  height: 16px;
  line-height: 16px;
  margin-left: 5px;
  font-size: 16px;
  color: #191919;
}

.main-price .buy_dialog .grid .grid_cell.u-1of3 .of3_first .package {
  margin-right: 10px;
}

.main-price .buy_dialog .grid .grid_cell.u-1of3 .of3_second {
  width: 100%;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  grid-template-rows: 1fr 1fr;
}

.main-price .buy_dialog .grid .grid_cell.u-1of3 .of3_second .select_item {
  background: linear-gradient(315deg, #FFFFFE 0%, #FDF8ED 100%);
  border: 1px solid #CC943A !important;
  border-radius: 6px;
}

.main-price .buy_dialog .grid .grid_cell.u-1of3 .of3_second .package_item {
  margin-top: 10px;
  border-radius: 6px;
  border: 1px solid #CDCDCD;
  width: 226px;
  height: 110px;
  color: #985512;
  position: relative;
}

.main-price .buy_dialog .grid .grid_cell.u-1of3 .of3_second .package_item .name {
  width: 100%;
  text-align: center;
  margin-top: 19px;
}

.main-price .buy_dialog .grid .grid_cell.u-1of3 .of3_second .package_item .price {
  margin-top: 26px;
  width: 100%;
  text-align: center;
  font-size: 14px;
  color: #985512;
}

.main-price .buy_dialog .grid .grid_cell.u-1of3 .of3_second .package_item .select {
  background: url("../../assets/images/package_select.png");
  background-size: 100% 100%;
  width: 30px;
  height: 30px;
  position: absolute;
  right: 0;
  bottom: 0;
}

.main-price .buy_dialog .grid .grid_cell.u-1of3 .of3_second .package_item .select .image {
  position: absolute;
  right: 0px;
  bottom: 0px;
  width: 60%;
  height: 60%;
}

.main-price .buy_dialog .grid .grid_cell.u-1of3 .of3_third {
  margin-top: 34px;
}

.main-price .buy_dialog .grid .grid_cell.u-1of3 .of3_third .title {
  display: flex;
  justify-content: flex-start;
  height: 16px;
  line-height: 16px;
}

.main-price .buy_dialog .grid .grid_cell.u-1of3 .of3_third .title .item {
  width: 2px;
  height: 16px;
  background-color: #1989FF;
}

.main-price .buy_dialog .grid .grid_cell.u-1of3 .of3_third .title .title_name {
  height: 16px;
  line-height: 16px;
  margin-left: 5px;
  font-size: 16px;
  color: #191919;
}

.main-price .buy_dialog .grid .grid_cell.u-1of3 .of3_third .payway {
  width: 100%;
  display: flex;
  justify-content: flex-start;
}

.main-price .buy_dialog .grid .grid_cell.u-1of3 .of3_third .payway .select_payway {
  background: #F3F9FF;
  border: 1px solid #1989FF !important;
}

.main-price .buy_dialog .grid .grid_cell.u-1of3 .of3_third .payway .payway_item {
  width: 135px;
  height: 58px;
  margin-right: 30px;
  margin-top: 16px;
  margin-bottom: 30px;
  border-radius: 6px;
  line-height: 58px;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px solid #CDCDCD;
}

.main-price .buy_dialog .grid .grid_cell.u-1of3 .of3_third .payway .payway_item div {
  margin-left: 5px;
}

.main-price .buy_dialog .grid .grid_cell.u-1of1 {
  flex: 0 0 320px;
  margin-top: 10px;
}

.main-price .buy_dialog .grid .grid_cell.u-1of1 .of1_first {
  width: 100%;
  height: 48px;
  display: flex;
  justify-content: space-evenly;
}

.main-price .buy_dialog .grid .grid_cell.u-1of1 .of1_first .of1_first_left {
  width: 48px;
  height: 48px;
  line-height: 48px;
  text-align: center;
  font-size: 16px;
  color: #fff;
  background: #1989FF;
  border-radius: 4px;
}

.main-price .buy_dialog .grid .grid_cell.u-1of1 .of1_first .of1_first_right {
  width: 240px;
  height: 44px;
}

.main-price .buy_dialog .grid .grid_cell.u-1of1 .of1_first .of1_first_right .name {
  font-size: 15px;
  line-height: 21px;
  color: #191919;
}

.main-price .buy_dialog .grid .grid_cell.u-1of1 .of1_first .of1_first_right .time {
  font-size: 12px;
  line-height: 17px;
  color: #8A94A9;
  margin-top: 7px;
}

.main-price .buy_dialog .grid .grid_cell.u-1of1 .of1_second {
  margin: 0 auto;
  width: 90%;
}

.main-price .buy_dialog .grid .grid_cell.u-1of1 .of1_second .of1_second_item {
  margin-top: 20px;
  display: flex;
  justify-content: space-between;
}

.main-price .buy_dialog .grid .grid_cell.u-1of1 .of1_second .of1_second_item :nth-child(1) {
  font-size: 12px;
  line-height: 17px;
  color: #8A94A9;
}

.main-price .buy_dialog .grid .grid_cell.u-1of1 .of1_second .of1_second_item :nth-child(2) {
  font-size: 12px;
  line-height: 17px;
  color: #191919;
}

.main-price .buy_dialog .grid .grid_cell.u-1of1 .of1_third {
  width: 90%;
  border: 1px dashed #CDCDCD;
  margin: 0 auto;
  margin-top: 30px;
}

.main-price .buy_dialog .grid .grid_cell.u-1of1 .of1_four {
  margin: 0 auto;
  margin-top: 35px;
  width: 90%;
  display: flex;
  justify-content: space-between;
  height: 28px;
}

.main-price .buy_dialog .grid .grid_cell.u-1of1 .of1_four :nth-child(1) {
  font-size: 12px;
  color: #191919;
  height: 28px;
  line-height: 28px;
}

.main-price .buy_dialog .grid .grid_cell.u-1of1 .of1_four :nth-child(2) {
  font-size: 20px;
  color: #EC2B4A;
  height: 28px;
  line-height: 28px;
}

.main-price .buy_dialog .grid .grid_cell.u-1of1 .of1_five {
  width: 90%;
  margin: 0 auto;
  margin-top: 26px;
}

.main-price .buy_dialog .grid .grid_cell.u-1of1 .of1_five ::v-deep .el-button {
  width: 100%;
  height: 44px;
  border-radius: 4px;
  font-size: 16px;
  text-align: center;
}

.main-price .buy_dialog .grid .grid_cell.u-1of1 .of1_six {
  width: 90%;
  margin: 0 auto;
  margin-top: 12px;
  font-size: 14px;
  color: #985512;
}

.main-price .buy_dialog .grid .grid_cell.u-1of1 .qrcode1 {
  width: 100%;
  margin-top: 10px;
  display: flex;
  justify-content: center;
}

.main-price .content {
  padding: 60px 0 80px;
  background: url(../../assets/images/bg-price.jpg) top/cover;
}

.main-price .content .title {
  color: #191919;
  font-size: 26px;
  font-family: "PingFangSC-Regular", sans-serif;
  text-align: center;
  margin-bottom: 30px;
}

.main-price .content .desc {
  margin-bottom: 40px;
  text-align: center;
  color: #8a94a9;
  font-size: 16px;
}

.main-price .content .btn {
  width: 240px;
  line-height: 38px;
  border: 1px solid #1989ff;
  border-radius: 4px;
  color: #1989ff;
  background-color: #fff;
  font-size: 16px;
  text-align: center;
  margin: 0 auto 27px;
  cursor: pointer;
}

.main-price .content .btn:hover {
  background: #e6f2ff;
}

.main-price .content .banner {
  width: 1195px;
  height: 120px;
  background: url(../../assets/images/banner_p.png);
  margin-bottom: 24px;
}

.main-price .content .banner .box_1 {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  width: 100%;
}

.main-price .content .banner .box_1 .box_2 {
  margin-top: 10px;
  width: 100%;
  text-align: center;
}

.main-price .content .banner .box_1 .box_2 .text_4 {
  font-size: 24px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #333333;
  margin-right: 10px;
}

.main-price .content .banner .box_1 .box_2 .text_5,
.main-price .content .banner .box_1 .box_2 .text_7 {
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: 600;
  color: #FF3642;
}

.main-price .content .banner .box_1 .box_2 .text_6 {
  font-size: 40px;
  font-family: PingFang SC;
  font-weight: 500;
  color: red;
}

.main-price .content .banner .box_1 .text_8 {
  margin-top: 3px;
  text-align: center;
  width: 100%;
  font-size: 18px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #333333;
}

.main-price .content .price-group {
  display: flex;
  justify-content: space-between;
  width: 1190px;
  margin: 0 auto;
  padding-top: 2px;
  position: relative;
}

.main-price .content .price-group .single-price {
  // flex: 0 0 228px;
  flex: 0 0 290px;
  background: #fff;
  overflow: hidden;
  border-radius: 4px;
  box-shadow: 0 0 13px rgba(148, 165, 180, 0.27);
}

.main-price .content .price-group .single-price .top {
  border-radius: 4px;
  height: 299px;
  box-shadow: 0 0 13px rgba(148, 165, 180, 0.27);
}

.main-price .content .price-group .single-price .top .price-content {
  text-align: center;
  padding: 35px 0 56px;
  /* position: relative; */
}

.main-price .content .price-group .single-price .top .price-content .limit {
  position: absolute;
  top: -4px;
  left: 132px;
}

.main-price .content .price-group .single-price .top .price-content .banben {
  color: #fff;
  font-size: 24px;
  font-family: "PingFangSC-Medium", sans-serif;
  margin-bottom: 45px;
}

.main-price .content .price-group .single-price .top .price-content .number {
  color: #999999;
  font-size: 22px;
  margin-bottom: 25px;
}

.main-price .content .price-group .single-price .top .price-content .date-price {
  color: #fff;
  font-size: 14px;
  font-family: "PingFangSC-Semibold", sans-serif;
}

.main-price .content .price-group .single-price .top .price-content .date-price span {
  font-size: 36px;
}

.main-price .content .price-group .single-price .top .price-content .date-price .trailClass {
  border: 1px solid #3A95FE;
}

.main-price .content .price-group .single-price .top .price-content .date-price .buy_btn {
  margin: 0 auto;
  width: 160px;
  height: 36px;
  margin-top: 40px;
  background-color: #fff;
  line-height: 36px;
  border-radius: 4px;
  cursor: pointer;
}

.main-price .content .price-group .single-price .top .price-content .date-price .buy_btn:hover {
  transform: translateY(-2px);
}

.main-price .content .price-group .single-price .top .start {
  text-align: center;
  border-radius: 4px;
  width: 168px;
  height: 46px;
  line-height: 46px;
  margin: 0 auto;
  background: #1989ff;
  cursor: pointer;
}

.main-price .content .price-group .single-price .top .start span {
  color: white;
  font-size: 16px;
}

.main-price .content .price-group .single-price .top .start .btn-right {
  width: 20px;
  height: 12px;
  line-height: 12px;
}

.main-price .content .price-group .single-price .top .start .rightb img:nth-child(1) {
  display: none;
}

.main-price .content .price-group .single-price .top .start:hover {
  background: #0b72df;
}

.main-price .content .price-group .single-price .top .startbg {
  transition: all 0.2s;
  background: #ffffff;
}

.main-price .content .price-group .single-price .top .startbg span {
  color: #1989ff;
}

.main-price .content .price-group .single-price .top .startbg:hover {
  background: #1989ff;
}

.main-price .content .price-group .single-price .top .startbg:hover span {
  color: #fff;
}

.main-price .content .price-group .single-price .top .startbg:hover .rightb img:nth-child(1) {
  display: block;
}

.main-price .content .price-group .single-price .top .startbg:hover .rightb img:nth-child(2) {
  display: none;
}

.main-price .content .price-group .single-price .grjc {
  background: url(../../assets/images/grjc.png) center/cover;
}

.main-price .content .price-group .single-price .tybg {
  background: url(../../assets/images/qyjc.jpg) center/cover;
}

.main-price .content .price-group .single-price .ptbg {
  background: url(../../assets/images/ptbg.png) center/cover;
}

.main-price .content .price-group .single-price .ptbg .banben {
  color: #fff !important;
}

.main-price .content .price-group .single-price .ptbg .number {
  color: #fff !important;
}

.main-price .content .price-group .single-price .ptbg .date-price {
  color: #fff !important;
}

.main-price .content .price-group .single-price .jcbg {
  background: url(../../assets/images/jcbg.jpg) center/cover;
}

.main-price .content .price-group .single-price .jcbg .banben {
  color: #fff !important;
}

.main-price .content .price-group .single-price .jcbg .number {
  color: #fff !important;
}

.main-price .content .price-group .single-price .jcbg .date-price {
  color: #fff !important;
}

.main-price .content .price-group .single-price .jjbg {
  background: url(../../assets/images/jjbg.jpg) center/cover;
}

.main-price .content .price-group .single-price .jjbg .banben {
  color: #fff !important;
}

.main-price .content .price-group .single-price .jjbg .number {
  color: #fff !important;
}

.main-price .content .price-group .single-price .jjbg .date-price {
  color: #fff !important;
}

.main-price .content .price-group .single-price .zybg {
  background: url(../../assets/images/zybg.jpg) center/cover;
}

.main-price .content .price-group .single-price .main {
  // width: 228px;
  width: 290px;
  height: 100%;
}

.main-price .content .price-group .single-price .main .min-title {
  font-size: 16px;
  line-height: 46px;
  color: #191919;
  padding: 0 20px;
}

.main-price .content .price-group .single-price .main ul {
  list-style: none;
}

.main-price .content .price-group .single-price .main ul li {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 10px;
}

.main-price .content .price-group .single-price .main ul li p {
  color: #8a94a9;
  font-size: 14px;
}

.main-price .content .price-group .single-price .main ul li span {
  color: #191919;
  font-size: 14px;
  line-height: 46px;
}

.main-price .content .price-group .single-price .main ul li span img {
  width: 100%;
}

.main-price .content .price-group .single-price .main ul li:nth-child(odd) {
  background-color: #fafafa;
}

.main-price .content .price-group .single-price .main ul #line {
  white-space: pre-line;
  line-height: 30px;
  text-align: right;
  text-indent: 10px;
}

.main-price .content .price-group .single-price .bottom {
  padding: 40px 20px;
  border-radius: 0px 0px 4px 4px;
}

.main-price .content .price-group .single-price .bottom .product {
  position: relative;
}

.main-price .content .price-group .single-price .bottom .product .min-title {
  color: #999999;
  font-size: 16px;
  margin-bottom: 15px;
}

.main-price .content .price-group .single-price .bottom .product ul {
  list-style: none;
}

.main-price .content .price-group .single-price .bottom .product ul li {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.main-price .content .price-group .single-price .bottom .product ul li p {
  color: #191919;
  font-size: 14px;
}

.main-price .content .price-group .single-price .bottom .product ul li span {
  color: #999999;
  font-size: 14px;
}

.main-price .content .price-group .single-price .bottom .product ul li:not(:last-child) {
  margin-bottom: 15px;
}

.main-price .content .price-group .single-price .jcb .product ul li span {
  color: #6c99c7;
}

.main-price .content .price-group .single-price .jjb .product ul li span {
  color: #0074e5;
}

.main-price .content .price-group .single-price .zyb .product ul li span {
  color: #d1902e;
}

.main-price .content .benefit {
  margin-top: 60px;
}

.main-price .content .benefit .title {
  color: #191919;
  font-size: 20px;
  margin-bottom: 60px;
  text-align: center;
  font-family: "PingFangSC-Regular", sans-serif;
}

.main-price .content .benefit .benefit-group {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}

.main-price .content .benefit .benefit-group .single-benefit {
  flex: 0 0 285px;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 7px 16px;
  text-align: center;
  padding: 22px 0 20px;
  border: 1px solid #fff;
  transition: all 0.3s;
}

.main-price .content .benefit .benefit-group .single-benefit .icon {
  width: 124px;
  height: 100px;
  margin: 0 auto;
}

.main-price .content .benefit .benefit-group .single-benefit .min-title {
  font-size: 16px;
  color: #191919;
  margin-bottom: 19px;
  line-height: 1;
}

.main-price .content .benefit .benefit-group .single-benefit p {
  font-size: 14px;
  color: #8a94a9;
}

.main-price .content .benefit .benefit-group .single-benefit:hover {
  border: 1px solid #1989ff;
  transform: translateY(-2px);
}

.main-price .education {
  padding: 40px;
  background: url(../../assets/images/bg-jiaoyu.png) center/cover;
  text-align: center;
}

.main-price .education .title {
  color: #191919;
  margin-bottom: 29px;
  font-size: 26px;
  line-height: 1;
  font-family: "PingFangSC-Regular", sans-serif;
}

.main-price .education p {
  color: #8a94a9;
  font-size: 16px;
}

.main-price .education .btn-group {
  display: flex;
  justify-content: center;
  margin-top: 40px;
}

.main-price .education .btn-group .btn {
  border: 1px solid #1989ff;
  width: 120px;
  height: 46px;
  line-height: 46px;
  color: #1989ff;
  font-size: 16px;
  transition: all 0.3s;
  border-radius: 4px;
  margin: 0 25px;
  cursor: pointer;
}

.main-price .education .btn-group .btn a {
  color: #1989ff;
}

.main-price .education .btn-group .btn:hover {
  background: #e6f2ff;
}

.main-price .education .btn-group .bg {
  background: #1989ff;
  color: #fff;
}

.main-price .education .btn-group .bg:hover {
  background: #0b72df;
}
</style>
